<template>
    <g fill-rule="evenodd">
        <defs>
            <ellipse id="activeSwitcherIcon-b" cx="20.882" cy="9" rx="8.235" ry="8.129"/>
            <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="activeSwitcherIcon-a">
                <feMorphology radius=".5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
                <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
                <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" in="shadowBlurOuter1"/>
            </filter>
        </defs>
        <rect width="30" height="18" rx="9"/>
        <use fill="#000" filter="url(#activeSwitcherIcon-a)" xlink:href="#inactiveSwitcherIcon-b"/>
        <use stroke-opacity=".102" stroke="#000" fill="#FFF" xlink:href="#activeSwitcherIcon-b"/>
    </g>
</template>

<script>
export default {
    name: 'activeSwitcherIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 30 18');
    }
};
</script>
